import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Ajax } from "../Service/ajax";
import Swal from "sweetalert2";
import FormData from "form-data";
import mime from "mime";

export default function ImageForm() {
    const { organisationId } = JSON.parse(sessionStorage.getItem("application"));
    const [uri, setUri] = useState( `https://devapi.netikash.com/exposed/v1/mda/images/show?target=logo&target_id=`);
    const [categoryImage, setCategoryImage] = useState({});
    const [errorMessage, setErrorMessage] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [image, setImage] = useState(null);

    const resetForm = () => {
        setErrorMessage("");
        setImage(null);
    };

    const handleImageChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
            if (img.height > categoryImage.max_height || img.width > categoryImage.max_width) {
                setErrorMessage(`La taille de l'image (${img.height}x${img.width}) est trop grande, max: ${categoryImage.max_height}x${categoryImage.max_width}`);
            } else if (img.height < categoryImage.min_height || img.width < categoryImage.min_width) {
                setErrorMessage(`La taille de l'image (${img.height}x${img.width}) est trop petite, min: ${categoryImage.min_height}x${categoryImage.min_width}`);
            } else {
                setErrorMessage("");
                setSelectedFile(file);
                const reader = new FileReader();
                reader.onloadend = () => {
                    setImage({ uri: reader.result, fileName: file.name, mimeType: file.type });
                };
                reader.readAsDataURL(file);
            }
        };
    };

    useEffect(() => {
        (async () => {
            Ajax.getRequest("/api/v1/mda/categories?target=logo")
                .then(({ data }) => {
                    setCategoryImage(data);
                });
        })();
    }, []);

    const fetchData = async () => {
        setLoading(true);
        if (!image) return;
        const formData = new FormData();
        formData.append('file', selectedFile);
        try {
            const { data } = await Ajax.postRequest(`/api/v1/mda/images/upload?target=logo&target_id=${organisationId}`, formData, { headers: {"Content-Type": 'multipart/form-data' }});
            if(data.error){
                Swal.fire({
                    title: 'Error!',
                    text: `${data.message}`,
                    icon: 'error',
                    customClass: {
                        popup: 'custom-popup',
                        confirmButton: 'custom-button'
                    },
                    timer: 5000,  // Après 5 secondes, l'alerte se fermera automatiquement
                }).then(() => {
                    // Si l'utilisateur clique sur "OK" ou si le timer se termine
                    window.location.reload();  // Recharge la page
                });
            }else{
                Swal.fire({
                    title: 'Success !',
                    text: `Image Changer avec success.`,
                    icon: 'success',
                    customClass: {
                        popup: 'custom-popup',
                        confirmButton: 'custom-button'
                    },
                    timer: 5000,  // Après 5 secondes, l'alerte se fermera automatiquement
                }).then(() => {
                    // Si l'utilisateur clique sur "OK" ou si le timer se termine
                    window.location.reload();  // Recharge la page
                });
            }
            console.log('Upload Success:', data);
        } catch (error) {
            console.error('Upload Error:', error);
            Swal.fire({
                title: 'Error!',
                text: `Oups! Une erreur s'est produite, veuillez réessayer plus tard.`,
                icon: 'error',
                customClass: {
                    popup: 'custom-popup',
                    confirmButton: 'custom-button'
                },
                timer: 5000,  // Après 5 secondes, l'alerte se fermera automatiquement
            }).then(() => {
                // Si l'utilisateur clique sur "OK" ou si le timer se termine
                window.location.reload();  // Recharge la page
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <div className="modal-overlay" id={"overlay-" + organisationId}></div>
            <button
                type="button"
                className="btn btn-sm btn-outline-netikash w-100 "
                data-bs-toggle="modal"
                data-bs-target={"#" + organisationId}
                style={{
                    minWidth: "100px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                }}

            >
                <i className="bx bx-image-alt"></i> Changer Logo
            </button>

            <div className="modal fade" id={organisationId} tabIndex="-1" aria-hidden="true" data-bs-backdrop="static"
                 data-bs-keyboard="false" style={{ display: loading ? 'block' : 'none' }}>
                <div className="modal-dialog modal-lg d-flex justify-content-center align-items-center">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel3">CHANGE COMPANY LOGO</h5>
                        </div>
                        <div className="modal-body d-flex justify-content-center align-items-center flex-column">
                            <img className="card-img card-img-left rounded-circle mb-3 w-px-150 h-px-150"
                                 src={image ? image.uri : uri}
                                 alt="company logo" />
                            <div className="text-center">
                                <label className="form-label" htmlFor="basic-default-upload-file">Changer le logo de l'organisation</label>
                                <input type="file" accept="image/*" className="form-control"
                                       id="basic-default-upload-file" required=""
                                       onChange={handleImageChange} />
                            </div>

                            {/* Loader Spinner */}
                            {loading && <div className="spinner-border text-netikash mt-5" role="status">
                                <span className="visually-hidden">Chargement...</span>
                            </div>}
                        </div>

                        <div className="modal-footer">
                            {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
                            <button type="button" className="btn btn-outline-netikash" data-bs-dismiss="modal" onClick={resetForm} disabled={loading}>
                                Annuler
                            </button>
                            <button type="button" className="btn btn-netikash" onClick={fetchData} disabled={loading}>
                                {loading ? "Chargement..." : "Changer logo"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}